import { render, staticRenderFns } from "./VDrugsSummary.vue?vue&type=template&id=aa6d26aa&scoped=true&"
import script from "./VDrugsSummary.vue?vue&type=script&lang=js&"
export * from "./VDrugsSummary.vue?vue&type=script&lang=js&"
import style0 from "./VDrugsSummary.vue?vue&type=style&index=0&id=aa6d26aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d26aa",
  null
  
)

export default component.exports